import React from "react";
import ReviewCard from "../cards/ReviewCard";

const StudentsReviews = ({
  reviews = [],
  padding = "pl-4 sm:pl-6 2xl:pl-10",
  margin = "mt-10 sm:mt-14 md:mt-16 2xl:mt-[85px]",
  width = "max-w-[1730px]",
}) => {
  const hasReviews = Array.isArray(reviews) && reviews.length > 0;


  return (
    <div className="bg-[#F5F5F5] px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1920px] pb-12 pt-8 text-black sm:pb-16 sm:pt-10 md:pb-[88px] md:pt-[60px]">
        <h1 className="text-center text-[26px] font-bold leading-tight sm:text-[32px] sm:leading-[56px]">
          What Our Students Say
        </h1>
        <div className="flex justify-center">
          <p className="mt-3 max-w-[988px] text-center text-sm leading-5 sm:mt-4 sm:text-base sm:leading-[19px]">
            Our students love the hands-on experience and personalized guidance
            they receive in our courses. Here’s what some of them have to say
            about their learning journey with us
          </p>
        </div>

        <div className={`relative ${margin}`}>
          {hasReviews ? (
            <div
              className={`mx-auto grid w-full grid-cols-1 gap-x-4 gap-y-10 min-[480px]:grid-cols-2 md:gap-x-[22px] md:gap-y-14 xl:grid-cols-4 ${width}`}
            >
              {reviews.map((itm) => (
                <ReviewCard key={itm._id} object={itm} padding={padding} />
              ))}
            </div>
          ) : (
            <div className="mx-auto flex max-w-[988px] flex-col items-center justify-center rounded-[14px] border border-dashed border-[#D1D5DB] bg-white px-4 py-10 text-center sm:rounded-[18px] sm:px-6 sm:py-12">
              <p className="text-base font-semibold text-[#1D2026] sm:text-lg">
                No reviews yet
              </p>
              <p className="mt-2 text-sm leading-5 text-[#6E7485]">
                Student feedback for this course will appear here once reviews
                are submitted.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentsReviews;
